import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export const useScheduleConfirm = () => {
  const [pending, setPending] = useState(null);
  const schedule = async (orderId, body) => {
    try {
      return await api.post(`/orders/${orderId}/schedule`, body);
    } catch (e) {
      if (e.response?.status !== 409) throw e;
      const ok = await new Promise((resolve) => setPending({ msg: errMsg(e), resolve }));
      return ok ? api.post(`/orders/${orderId}/schedule`, { ...body, force: true }) : null;
    }
  };
  const close = (ok) => {
    pending?.resolve(ok);
    setPending(null);
  };
  const dialog = (
    <AlertDialog open={!!pending} onOpenChange={(o) => !o && close(false)}>
      <AlertDialogContent data-testid="availability-warning-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl">Tecnico non disponibile</AlertDialogTitle>
          <AlertDialogDescription data-testid="availability-warning-text">{pending?.msg}. Vuoi confermare comunque l'assegnazione? La forzatura resterà tracciata nello storico dell'ordine.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => close(false)} data-testid="availability-warning-cancel">Annulla</AlertDialogCancel>
          <AlertDialogAction onClick={() => close(true)} data-testid="availability-warning-confirm">Conferma comunque</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
  return [schedule, dialog];
};
